import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// const salesData = [
//   { label: "Total Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Credit Sale", today: "0.00", monthly: "0.00" },
//   { label: "Expenses", today: "0.00", monthly: "14000.00" },
//   { label: "Number of Bills", today: "0", monthly: "38" },
//   { label: "Product Sold", today: "0", monthly: "58" },
//   { label: "Service Sold", today: "0", monthly: "26" },
// ];

const TableReport = ({ salesData, colName, data }) => {
  return (
    <Box
      sx={{
        py: "20px",
        px: { xs: "10px", sm: "50px" },
        background: "white",
        borderRadius: "10px",
        height: "50vh",
      }}
    >
      <Grid container spacing={1}>
        <Grid container spacing={1} sx={{ borderBottom: "1px solid #1E1E1E" }}>
          <Grid item xs={3}>
            <Typography
              fontWeight="500"
              color="primary"
              sx={{
                paddingLeft: { xs: "1px", sm: "50px" },
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Category
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              align="center"
              fontWeight="500"
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Items
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              align="center"
              fontWeight="500"
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Amount
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              align="center"
              fontWeight="500"
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Percent
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            paddingTop: "10px",
            overflow: "auto",
          }}
        >
          {data?.map((item, idx) => (
            <Grid
              item
              xs={12}
              container
              key={idx}
              elevation={2}
              sx={{
                borderRadius: "10px",
                my: "5px",
                background: "#E3E3FF",
              }}
            >
              <Grid item xs={3}>
                <Box p={1}>
                  <Typography
                    fontWeight={500}
                    sx={{
                      paddingLeft: { xs: "10px", sm: "40px", md:"50px" },
                      align: "left",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {item.itemCategory}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3} pr={{ xs: 2, sm: 5, md:8, lg:14 }}>
                <Box p={1} px={1}>
                  <Typography
                    fontWeight={500}
                    align="right"
                    sx={{
                      // paddingLeft: "40px",
                      align: "right",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {item.items}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3} pr={{ xs: 1, sm: 2 }}>
                <Box p={1} px={{xs:0, sm:2, md:5, lg:12}}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ width: "100%" }}
                  >
                    <CurrencyRupeeIcon
                      sx={{ fontSize: "16px", color: "#000" }}
                    />
                    <Typography
                      fontWeight={500}
                      align="right"
                      sx={{
                        flex: 1,
                        textAlign: "right",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {item.amount?.toFixed(2)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={3} pr={{ xs: 0, sm: 3, md:5 ,lg:12}}>
                <Box p={1}>
                  <Typography
                    fontWeight={500}
                    align="right"
                    sx={{
                      // paddingLeft: "20px",
                      align: "left",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                  >
                    {item.percentage?.toFixed(2)} %
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableReport;
